// Accordion: only one collapsible row open at a time
document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('details');

  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', () => {
      if (accordion.open) {
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== accordion && otherAccordion.open) {
            otherAccordion.removeAttribute('open');
          }
        });
      }
    });
  });
});

// Cart terms / checkout 
document.addEventListener("DOMContentLoaded", () => {

  function updateCheckoutState() {
    const checkbox = document.getElementById("agree-terms");
    const checkout = document.getElementById("checkout");

    if (!checkbox || !checkout) return;

    // Parcely pole checkouti veel lubanud
    if (checkout.disabled) {
      checkout.classList.remove("terms-disabled");
      return;
    }

    // Parcely lubas checkouti
    if (!checkbox.checked) {
      checkout.classList.add("terms-disabled");
    } else {
      checkout.classList.remove("terms-disabled");
    }
  }

  document.addEventListener("change", (e) => {
    if (e.target.id === "agree-terms") {
      updateCheckoutState();
    }
  });

  const checkout = document.getElementById("checkout");

  if (checkout) {
    new MutationObserver(updateCheckoutState).observe(checkout, {
      attributes: true,
      attributeFilter: ["disabled"]
    });
  }

  document.addEventListener("click", function (e) {
    const button = e.target.closest("#checkout");
    if (!button) return;

    const checkbox = document.getElementById("agree-terms");
    if (!checkbox) return;

    // Parcely ise blokeerib
    if (button.disabled) return;

    // Meie blokeerime tingimused
    if (!checkbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const error = document.getElementById("terms-error");
      if (error) error.style.display = "block";

      checkbox.focus();
    }
  }, true);

  updateCheckoutState();
});